import { GroupByMode, newTaskSuffix } from '@griply/types';
import { getNewTaskPrefill } from '@griply/utils';
import React from 'react';
import { NewTaskRow } from 'shared/components/connected/new-task-row';
import {
  RenderItemProps,
  TaskListItemTypes,
} from 'shared/components/ui/virtualized-tree-list';

import { PriorityHeader } from '../priority-header';
import { TreeTaskCard } from '../tree-task-card';
import { usePriorityRenderData } from './priority-render-context';

export const PriorityRenderItem: React.FC<RenderItemProps> = ({
  item,
  itemInstance,
  tree,
  isMultiSelectModifierPressed,
}) => {
  const {
    groupSettings,
    tasksMap,
    tasks,
    today,
    denseFormat,
    defaultNewTaskDate,
  } = usePriorityRenderData();

  const type = item.type;

  if (type === TaskListItemTypes.Task) {
    const task = tasksMap[item.sourceId];
    if (!task) {
      return null;
    }
    return (
      <TreeTaskCard
        task={task}
        tree={tree}
        item={itemInstance}
        tasks={tasks}
        isMultiSelectModifierPressed={isMultiSelectModifierPressed}
        displayDue={groupSettings.displayDue}
      />
    );
  }

  if (type === TaskListItemTypes.NewTask) {
    const groupSectionId = item.sourceId.replace(newTaskSuffix, '');
    const prefill = getNewTaskPrefill({
      groupByMode: GroupByMode.Priority,
      groupSectionId,
      groupSetting: groupSettings,
      today,
      defaultNewTaskDate,
    });
    return (
      <NewTaskRow
        priority={prefill.priority}
        date={prefill.startDate}
        startTime={null}
        duration={null}
        goal={prefill.goalId}
        lifeArea={prefill.lifeAreaId}
        tags={prefill.tagIds}
      />
    );
  }

  if (type === TaskListItemTypes.Priority) {
    return <PriorityHeader denseFormat={denseFormat} item={itemInstance} />;
  }

  return null;
};
